import AiDevelopmentStoriesPage from "../../pages/aiDevelopment/AiDevelopmentStoriesPage";

const route = { key: "aiDevelopmentStories", path: "/ai-development/stories", component: AiDevelopmentStoriesPage,
  permission: "ai.development.read", private: true, layout: "main", icon: "faCode", group: "aiDevelopment", order: 10 };
export default route;
